import React, { useState } from "react";
import { Inbox, Search } from "lucide-react";
import FilterDropdown from "./FilterDropdown";
import { SEVERITIES, SEVERITY_COLOR, STATUSES, STATUS_COLOR, TYPE_META } from "./constants";

const TABS = [
  { value: "", label: "All requests", icon: Inbox, color: "var(--muted)" },
  { value: "issue", label: "Issues" },
  { value: "feature_request", label: "Features" },
  { value: "suggestion", label: "Suggestions" },
];

const RequestsToolbar = ({ filters, setFilter, counts, showUnread }) => {
  const [openDd, setOpenDd] = useState(null); // "status" | "severity" | null
  const dd = (key, label, anyLabel, options) => (
    <FilterDropdown
      label={label}
      anyLabel={anyLabel}
      options={options}
      value={filters[key]}
      open={openDd === key}
      onToggle={() => setOpenDd(openDd === key ? null : key)}
      onClose={() => setOpenDd(null)}
      onChange={(v) => setFilter(key)(v)}
    />
  );

  return (
    <div className="er-toolbar">
      <div className="er-tabs" role="tablist" aria-label="Request type">
        {TABS.map((t) => {
          const meta = TYPE_META[t.value];
          const Icon = t.icon || meta.icon;
          const on = filters.type === t.value;
          return (
            <button key={t.value || "all"} type="button" role="tab" aria-selected={on} className={`er-btn er-tab${on ? " on" : ""}`} onClick={() => setFilter("type")(t.value)}>
              <Icon size={14} strokeWidth={1.9} color={meta?.color || t.color} />
              {t.label}
              <small>{counts[t.value || "all"] ?? 0}</small>
            </button>
          );
        })}
      </div>

      <label className="er-search">
        <Search size={15} strokeWidth={1.8} />
        <input
          dir="auto"
          value={filters.q}
          onChange={(e) => setFilter("q")(e.target.value)}
          placeholder="Search title or employee…"
          aria-label="Search title or employee"
        />
      </label>

      {dd("status", "Status", "Any status", STATUSES.map((s) => ({ ...s, color: STATUS_COLOR[s.value] })))}
      {dd("severity", "Severity", "Any severity", SEVERITIES.map((s) => ({ ...s, color: SEVERITY_COLOR[s.value] })))}

      {showUnread && (
        <button
          type="button"
          role="switch"
          aria-checked={filters.unread === "true"}
          className={`er-btn er-switch${filters.unread === "true" ? " on" : ""}`}
          onClick={() => setFilter("unread")(filters.unread === "true" ? "" : "true")}
        >
          <span className="er-track"><span className="er-knob" /></span>
          Unread only
        </button>
      )}
    </div>
  );
};

export default RequestsToolbar;
